import "./CustomTooltip.css";

const CustomTooltip = ({
  title,
  subtitle,
  icon,
  children,
  position = "top",
  button,
  enabled = true,
}) => {
  return enabled ? (
    <div className={`custom_tooltip custom_tooltip-${position}`}>
      <div className="custom_tooltip-content">
        <div className="custom_tooltip-title">
          {icon && <span style={{ marginRight: "5px" }}>{icon}</span>}
          {title}
        </div>
        {subtitle && (
          <div className="custom_tooltip-subtitle">
            <i>{subtitle}</i>
          </div>
        )}
        {button && <div className="custom_tooltip-button">{button}</div>}
      </div>
      {children}
    </div>
  ) : (
    <>{children}</>
  );
};

export default CustomTooltip;
